module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.73f0a88.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/atmosphere-mask/font/Roboto-Regular.woff2
// module id = purV
// module chunks = 0